import styled from "styled-components";
import { Select } from 'antd';

export const Container = styled("div")`
  display: inline;
  width: 100%;
`;

export const StyledSelect2 =  styled(Select)`
  height: 55px;
  width:100%;
  
  :focus-within {
      background: none;
      box-shadow: RED 0px 0px 0px 1px;
  }

  background-color:#e6e6e6;
  padding-left:10px;
  font-size: 12px;
  text-align:right;
`;



export const StyledSelect = styled(Select)`

    border-radius: 5px;
    margin-bottom:5px;
    margin-right:5px;
    width:200px;   
    min-width:300px;
    background-color:#e6e6e6;

    :focus-within {
            background: none;
            box-shadow: #f0da13 0px 0px 0px 1px;
    }

  /* .ant-select-selector {
    height: 155px;
  }

  .ant-select-selection-search{

    height: 55px;
    margin:0px;
  }

  .ant-select-selection-item{
    height: 55px;
  }

  .ant-select-arrow{
      color: blue !important;
      font-size: 15px !important;
    }

    .ant-select-selection-search-input {
      background-color: yellow;
      height: 55px;
      width:200px;
    } */
  
    /* :focus-within {
      background: none;
      box-shadow: RED 0px 0px 0px 1px;
    }

    .ant-select-selection-search-input {
      height: 55px;
      width:200px;
    }

    .ant-select-arrow{
      color: #F0DA13 !important;
      font-size: 15px !important;
    }
    .ant-select-selector{
      background-color:#e6e6e6 !important;
    }
    .ant-select-selection-placeholder{
      color:#a8a8a8 !important;
      height: 55px;
    }
    .ant-select {
      height: 55px;
    } */


`;